<span class="p-input-icon-left ag-grid-toolbar-search ai-table-search">
  <i class="pi" [ngClass]="mode === 'ai' ? 'pi-sparkles' : 'pi-search'"></i>

  <input
    pInputText
    type="text"
    [placeholder]="placeholder"
    [(ngModel)]="term"
    (input)="onInput()"
  />


  <i
    class="pi pi-question-circle ai-table-search__help"
    *ngIf="mode === 'ai'"
    pTooltip="Words are combined, so more words narrows the results.
Use quotes for a phrase: &quot;swimming pool&quot;.
Scope to one attribute: style:zen or time_of_day:midday.
A number on its own looks up that record id."
    tooltipPosition="bottom"
    [escape]="false"
  ></i>
</span>

<p-selectButton
  class="ai-table-search__mode"
  [options]="modeOptions"
  optionLabel="label"
  optionValue="value"
  [allowEmpty]="false"
  [ngModel]="mode"
  (ngModelChange)="onModeChange($event)"
>
  <ng-template let-option pTemplate="item">
    <span [pTooltip]="option.tooltip" tooltipPosition="bottom">{{ option.label }}</span>
  </ng-template>
</p-selectButton>
